// extracted by mini-css-extract-plugin
export default {"icon":"_iUBdAqkNxCNAGSniCMZ__icon___"};